export default __webpack_public_path__ + "static/media/bloodfountain.18443439.png";